import { useCreateOne } from '@/queries/admin';
import { useNavigate } from 'react-router-dom';
import { Form, FormData } from './Form';
import toast from 'react-hot-toast';
import { ROUTES } from '@/config/routes';
import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';

export const Create = () => {
  const navigate = useNavigate();
  const { mutateAsync: createApplicationLink } = useCreateOne('application-links');

  const onSubmit = async (data: FormData) => {
    try {
      await createApplicationLink({ data });
      toast.success('Ссылка успешно обновлена');
      navigate(ROUTES.ADMIN.APPLICATION_LINKS);
    } catch (error) {
      console.error('Error updating:', error);
      toast.error('Произошла ошибка при обновлении ссылки');
    }
  };

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Ссылки на документы',
          href: ROUTES.ADMIN.APPLICATION_LINKS,
        },
        {
          label: 'Создание',
          href: '',
        },
      ]}
    >
      <Form onSubmit={onSubmit} />
    </PageLayout>
  );
};
